import { supabase } from "../config/supabase";

// saved_remarks / saved_remark_files READS through the anon client. Writes go
// through the backend: services/savedRemarks.ts (rows) - the Storage objects
// themselves are still written from the browser, through api/storage.ts.

/** The bucket saved-remark files are uploaded to (a row may name its own). */
export const SAVED_REMARK_FILES_BUCKET = "saved-remark-files";

/** Every active saved remark, most recently updated first. */
export const listActiveSavedRemarks = () =>
  supabase.from("saved_remarks").select("*").eq("is_active", true).order("updated_at", { ascending: false });

/** Every active saved-remark file, oldest first. */
export const listActiveSavedRemarkFiles = () =>
  supabase.from("saved_remark_files").select("*").eq("is_active", true).order("created_at", { ascending: true });

/** One saved-remark file row. */
export const getSavedRemarkFile = (fileId: number) =>
  supabase.from("saved_remark_files").select("*").eq("id", fileId).single();

/**
 * The active files of these saved remarks, as the quote preview lists them
 * (metadata only: the backend attaches the files at send time).
 */
export const listSavedRemarkFilePreviews = (savedRemarkIds: number[]) =>
  supabase
    .from("saved_remark_files")
    .select("id, saved_remark_id, original_filename, mime_type, file_size")
    .in("saved_remark_id", savedRemarkIds)
    .eq("is_active", true);
